import { eventNames, useCoreEvents } from '@carvana/core-events';
import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import { useGetUser, useIsLoggedIn } from '~/context/common/UserContext';
import ModalContext from '~/context/sem/ModalContext';
import HamburgerMenu from '~/icons/HamburgerMenu';
import UserProfileIcon from '~/icons/UserProfile';

export default function HeaderAccountItem() {
  const { setHeaderMenuModalOpen } = useContext(ModalContext);
  const { emit } = useCoreEvents();
  const { given_name: givenName } = useGetUser();
  const isLoggedIn = useIsLoggedIn();

  return (
    <>
      {/* Non-desktop */}
      <Clickable
        className="l:hidden"
        onClick={() => {
          setHeaderMenuModalOpen(true);
        }}
        data-analytics-id="Header Menu - Opened"
      >
        <span className="sr-only">Menu</span>
        <HamburgerMenu />
      </Clickable>

      {/* Desktop */}
      <div className="hidden l:block">
        {isLoggedIn ? (
          <a
            href="/account-ui/personal-details"
            className="flex items-center gap-8 text-blue-6 hover:text-blue-6"
            data-analytics-id="Header - Personal Details"
          >
            <UserProfileIcon />
            <span className="normal-case tl-body-m">{givenName}</span>
          </a>
        ) : (
          <Clickable
            className="text-blue-2 tl-header-s"
            onClick={() => {
              emit(eventNames.accountModal.open);
            }}
            data-analytics-id="Header - Sign In"
          >
            Sign In
          </Clickable>
        )}
      </div>
    </>
  );
}
